module.exports = __webpack_public_path__ + "media/images/reviewIcon-941b483f.png";